import Bugsnag from "@bugsnag/js";
import fetchBodyParts from "./fetchBodyParts";
import updateBodyPartOptions from "./updateBodyPartOptions";
import initialiseBodyPartSelect from "./initialiseBodyPartSelect";
import clearPriceCheckerResult from "./clearPriceCheckerResult";
import { isModalitySelect, MODALITY_SELECT_SELECTOR } from "./modalitySelect";

const handleModalityChange = async (event: Event) => {
  const form = event.currentTarget as HTMLFormElement;
  const target = event.target;

  if (
    !(target instanceof HTMLSelectElement) ||
    !(form instanceof HTMLFormElement)
  )
    return;

  if (!isModalitySelect(target)) return;

  await refreshBodyParts(form, target);

  clearPriceCheckerResult(form);
};

const refreshBodyParts = async (
  form: HTMLFormElement,
  modalitySelect?: HTMLSelectElement,
  preserveSelections = false
) => {
  const target =
    modalitySelect ||
    form.querySelector<HTMLSelectElement>(MODALITY_SELECT_SELECTOR);

  if (!target || !target.value) {
    return;
  }

  const locationId = target.dataset.locationId;

  let selectedValues: Array<string> | null = null;

  if (preserveSelections) {
    const formElement = form as HTMLFormElement & {
      bodyPartMultiSelect?: { selectedValues?: string[] };
    };

    const bodyPartSelect = form.querySelector<HTMLSelectElement>(
      "select[data-multi-select-init='true']"
    );

    if (formElement.bodyPartMultiSelect?.selectedValues?.length) {
      selectedValues = [...formElement.bodyPartMultiSelect.selectedValues];
    } else if (bodyPartSelect) {
      selectedValues = Array.from(bodyPartSelect.selectedOptions).map(
        (option) => option.value
      );
    }
  }

  try {
    const bodyParts = await fetchBodyParts(target.value, locationId);

    updateBodyPartOptions(form, bodyParts, selectedValues);

    initialiseBodyPartSelect(form);
  } catch (error) {
    Bugsnag.notify(error);
  }
};

export default handleModalityChange;

export { refreshBodyParts };
